import { render } from "./StatisticsPortalExportButtons.vue?vue&type=template&id=0945f2f2&ts=true"
import script from "./StatisticsPortalExportButtons.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalExportButtons.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__